/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="bcdd3f9e-4a31-4d9e-8110-681f5cf98270" width="20.51" height="22.76" viewBox="0 0 20.51 22.76" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <g id="a5f3e071-f572-4089-8d0e-98ac5e16d244">
          <g id="b5682e6d-cfa5-4e95-982c-9a79ee514fa5">
            <g id="aae8364c-b0f5-437d-aa9c-5b00f15bd48e">
              <path id="fbc75586-ef04-409a-a80e-f1743e5f3a3e" d="M9.8.54a4.67,4.67,0,0,1,4.34,1.13,3,3,0,0,1,.94,1.81,10.25,10.25,0,0,1-4,19.68h0a10.24,10.24,0,0,1-.57-20.47h.57A10.07,10.07,0,0,1,13.67,3a2.84,2.84,0,0,0-.37-.47,3.52,3.52,0,0,0-3.24-.82h0l-.18,0L9.62.58Zm5,4.14a3.46,3.46,0,0,1-2.32,2,7.37,7.37,0,0,1-2,.28,5.33,5.33,0,0,1-2.74-.65,1.69,1.69,0,0,1-.86-1.38,9.07,9.07,0,1,0,8-.21ZM6.38,16.07l.13.12A6.17,6.17,0,0,0,10.78,18a6.13,6.13,0,0,0,4.12-1.65h0l.13-.12.8.89-.13.12a7.26,7.26,0,0,1-4.92,2,7.38,7.38,0,0,1-5.1-2.12h0l-.13-.12ZM7.09,11a1.18,1.18,0,1,1-1.18,1.18A1.18,1.18,0,0,1,7.09,11Zm7.39,0a1.18,1.18,0,1,1-1.19,1.18A1.18,1.18,0,0,1,14.48,11Zm-3.43-7.1h-.37A9.14,9.14,0,0,0,9,4.12c-.7.17-.94.51-1,.68s.18.38.31.47a5.53,5.53,0,0,0,3.76.23,2.32,2.32,0,0,0,1.57-1.22,8.9,8.9,0,0,0-2.66-.41Z" transform="translate(-0.8 -0.4)" className="icon-fill"/>
            </g>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'BabyFaceIcon';

export default Icon;
